import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from './client';
import type { ItemCategory, CreateItemCategory, UpdateItemCategory, ReorderItemCategories } from '@estimator/shared';

export function useItemCategories(activeOnly = false) {
  return useQuery({
    queryKey: ['item-categories', { activeOnly }],
    queryFn: async () => {
      const params = activeOnly ? '?active=true' : '';
      const { data } = await apiClient.get<ItemCategory[]>(`/item-categories${params}`);
      return data;
    },
  });
}

export function useCreateItemCategory() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body: CreateItemCategory) => {
      const { data } = await apiClient.post<ItemCategory>('/item-categories', body);
      return data;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['item-categories'] }),
  });
}

export function useUpdateItemCategory() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...body }: UpdateItemCategory & { id: string }) => {
      const { data } = await apiClient.patch<ItemCategory>(`/item-categories/${id}`, body);
      return data;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['item-categories'] }),
  });
}

export function useReorderItemCategories() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (body: ReorderItemCategories) => {
      const { data } = await apiClient.patch<ItemCategory[]>('/item-categories/reorder', body);
      return data;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['item-categories'] }),
  });
}
